import { FC, memo } from "react";
import { NewVirtualOrderProps } from "./OrderService.interface";

const NewVirtualOrders: FC<NewVirtualOrderProps> = ({
    onNewImagemoptionVideo,
    onNewVirtualStaging
}) => {
    return (<>
        <div className="upsell-button virtual-staging-button" onClick={onNewVirtualStaging} title={'Create new Virtual Staging order based on the seleted photos'}></div>
        <div className="upsell-button imagemotion-video-button" onClick={onNewImagemoptionVideo} title={'Create new Imagemotion video order based on the seleted photos'}></div>  
    </>);
}

export default memo(NewVirtualOrders);